export const P00061PositionType = [
  { ref: 0, label: 'P00043.positiontype.0' },
  { ref: 1, label: 'P00043.positiontype.1' },
];
